export default "__VITE_ASSET__D6LzFtZ3__ 720w";